import { render, staticRenderFns } from "./OrderIntakeForm.vue?vue&type=template&id=385802a6"
import script from "./OrderIntakeForm.vue?vue&type=script&lang=js"
export * from "./OrderIntakeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports